import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

import PeopleOnMove from '../pages/PeopleOnMove';
import LeadershipTeam from '../pages/LeadershipTeam';
import LoginPage from '../pages/LoginPage';
import ContactUs from '../pages/ContactUs';
import EmployeeDirectory from '../pages/EmployeeDirectory';
import NewsEvents from '../pages/NewsEvents';
import Policies from '../pages/Policies';
import Hero from '../pages/Hero';
import Timeline from '../pages/Timeline';
import OrganizationChart from '../pages/OrganizationChart';
import BeforeLogin from '../pages/BeforeLogin';
import SelectDashboardSmith from '../pages/SelectDashboardSmith';
import Dashboard from '../pages/SelectDashboard';
import EmployeeBirthday from '../pages/BirthdayList';
import EmployeeAnniversaryCards from '../pages/AnniversaryList';
import NewsEventDetail from '../pages/NewsEventDetails';
import Brands from '../pages/Brands';
import Products from '../pages/Products';
import Engagement from '../pages/Engagement';
import Downloads from '../pages/Downloads';
import BlogsList from '../pages/BlogsList';
import BlogDetails from '../pages/BlogDetails';
import VideosList from '../pages/VideosList';
// import SelectDashboardPureIt from '../pages/SelectDashboardPureIt';

const validPaths = [
  '/',
  '/login',
  '/leadership',
  '/contact',
  '/people-on-move',
  '/employee-directory',
  '/news-events',
  '/policies',
  '/about',
  '/organization-chart',  
  '/before-login',
  '/select-dashboard-smith',
  '/select-dashboard',
  '/downloads',
  'birthday-list'
  // '/select-dashboard-pureit'
];

const AppRoutes = () => {
  const location = useLocation();
  const [lastValidPath, setLastValidPath] = useState(location.pathname);

  useEffect(() => {
    if (validPaths.includes(location.pathname)) {
      setLastValidPath(location.pathname);
    }
  }, [location.pathname]);

  return (
    <Routes >
      
      <Route  path="/" element={<Hero />} /> 
      <Route path="/login" element={<LoginPage />} /> 
      <Route path="/leadership" element={<LeadershipTeam />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/people-on-move" element={<PeopleOnMove />} />
      <Route path="/employee-directory" element={<EmployeeDirectory />} />
      <Route path="/news-events" element={<NewsEvents />} />
      <Route path='/policies' element={<Policies />} />
      <Route path="/about" element={<Timeline />} />
      <Route path="/organization-chart" element={<OrganizationChart />} />
      <Route path="/before-login" element={<Dashboard />} />
      <Route path="/select-dashboard" element={<Dashboard />} />
      <Route path="/downloads" element={<Downloads />} />
      <Route  path="/birthday-list" element={<EmployeeBirthday />} />
      <Route  path="/anniversary-list" element={<EmployeeAnniversaryCards />} />
  <Route path="/brands" element={<Brands />} />
        <Route path="/products" element={<Products />} />
        <Route path="/engagement" element={<Engagement />} />
      <Route path="/news-events/:id" element={<NewsEventDetail />} />
      <Route path="/blogs" element={<BlogsList />} />
      <Route path="/blogs/:id" element={<BlogDetails />} />
      <Route path="/videos" element={<VideosList />} />
      {/* <Route path="/dashboard-page" element={<Dashboard />} /> */}

    </Routes>
  );
};

export default AppRoutes;
